<p-dialog header="Modifica Mezzo di Trasporto" styleClass="accrediti-dialog" (visibleChange)="onClose()" [focusOnShow]="false" [(visible)]="visible" [modal]="true" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '70vw' }">
    <form class="accrediti-form flex flex-col gap-6" [formGroup]="formMezzo">

        <div class="w-full flex flex-col">
            <label>* Tipo di Mezzo</label>     
            <p-autoComplete formControlName="tipo" [forceSelection]="true" [suggestions]="tipologie_filtrate" optionLabel="tipologia" [showEmptyMessage]="false" [dropdown]="true" (completeMethod)="onFilterTipologie($event)"/>
            @if (formMezzo.get('tipo')?.hasError('required') && (formMezzo.get('tipo')?.dirty || formMezzo.get('tipo')?.touched)) { <small class="text-red-600 block mt-4 font-medium">Il Tipo di Mezzo è obbligatoria!</small>}
        </div>      

        <div class="flex lg:flex-row flex-col gap-6">
            <div class="lg:w-1/2 w-full">
                <label>* Targa</label>
                <input type="text" pInputText formControlName="targa" name="targa" id="targa" required />
                @if (formMezzo.get('targa')?.hasError('required') && (formMezzo.get('targa')?.dirty || formMezzo.get('targa')?.touched)) { <small class="text-red-600 block mt-4 font-medium">La Targa è obbligatoria!</small>}
            </div>
            <div class="lg:w-1/2 w-full">
                <label>* Ditta</label>
                <input type="text" pInputText formControlName="azienda" name="azienda" id="azienda" required />
                @if (formMezzo.get('azienda')?.hasError('required') && (formMezzo.get('azienda')?.dirty || formMezzo.get('azienda')?.touched)) { <small class="text-red-600 block mt-4 font-medium">La Ditta è obbligatoria!</small>}
            </div>
        </div>
    
        <div class="acc-actions">
            <button type="button" class="acc-btn acc-btn-ghost" (click)="onClose();">Annulla</button>
            <button type="button" class="acc-btn acc-btn-primary" [disabled]="!formMezzo.valid" (click)="onEdit()">Modifica</button>
        </div>

    </form>    
</p-dialog>